import { createContext, useContext } from 'react';

/**
 * The shell layout (IA §4), decided by the shell's container width:
 * phone < 640 px, laptop 640–1919 px, ultrawide ≥ 1920 px.
 */
export type ShellLayout = 'phone' | 'laptop' | 'ultrawide';

export function layoutFor(width: number): ShellLayout {
  if (width > 0 && width < 640) return 'phone';
  if (width >= 1920) return 'ultrawide';
  return 'laptop';
}

export const LayoutContext = createContext<ShellLayout>('laptop');

export function useShellLayout(): ShellLayout {
  return useContext(LayoutContext);
}
